<template>
  <v-select
    :model-value="modelValue"
    :items="items"
    :menu-props="{ maxHeight: '300' }"
    class="filter-menu"
    menu-icon="icon-arrow-down-xs"
    :class="{ 'cui-filter-active': modelValue }"
    :placeholder="$t('manageWorkspaces.filters.policy')"
    density="compact"
    variant="outlined"
    rounded
    item-value="id"
    item-title="name"
    :clearable="clearable && !!modelValue"
    :disabled="disabled"
    @update:model-value="$emit('update:modelValue', $event ?? '')"
  >
    <template #selection="{ item }">
      <span class="body2 overflow-ellipsis">
        {{ item.title ? item.title : $t("manageWorkspaces.filters.policy") }}
      </span>
    </template>
    <template #item="{ item, props }">
      <v-list-item v-bind="props">
        <template v-slot:title>
          <span>{{ item.raw.name }}</span>
        </template>
      </v-list-item>
    </template>
  </v-select>
</template>

<script lang="ts">
import { defineComponent, type PropType } from "vue";
import type { GlobalPolicyListItem } from "@/_store/msp/global-policies/msp-global-policies.module.ts";

export default defineComponent({
  props: {
    modelValue: {
      type: String,
      default: "",
    },
    items: {
      type: Array as PropType<GlobalPolicyListItem[]>,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["update:modelValue"],
});
</script>
